import { render } from "./SkillAssessmentDialog.vue?vue&type=template&id=970f0aa4&scoped=true"
import script from "./SkillAssessmentDialog.vue?vue&type=script&lang=js"
export * from "./SkillAssessmentDialog.vue?vue&type=script&lang=js"

import "./SkillAssessmentDialog.vue?vue&type=style&index=0&id=970f0aa4&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-970f0aa4"]])

export default __exports__